import React from 'react';

interface TableLoadingSkeletonProps {
  rows?: number;
  columns?: number;
}

export const TableLoadingSkeleton: React.FC<TableLoadingSkeletonProps> = ({ rows = 8, columns = 6 }) => (
  <div className="animate-pulse overflow-hidden rounded-xl border border-border">
    <table className="min-w-full divide-y divide-border">
      <thead className="bg-surface-muted/80">
        <tr>
          {Array.from({ length: columns }).map((_, i) => (
            <th key={i} className="px-4 py-3 text-left">
              <div className="h-3 w-24 rounded bg-border" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-border bg-surface">
        {Array.from({ length: rows }).map((_, r) => (
          <tr key={r}>
            {Array.from({ length: columns }).map((__, c) => (
              <td key={c} className="px-4 py-3">
                <div className="h-4 w-full max-w-[10rem] rounded bg-border" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
